export const trendClass = (trend) => {
  if (trend === "increased") return "kbv-v25-odt-odds--up";
  if (trend === "decreased") return "kbv-v25-odt-odds--down";
  return "";
};
